// eslint-disable-next-line import/no-anonymous-default-export
export default `swagger: "2.0"
info:
  version: "0.0.1"
  title: document-portal-api
# during dev, should point to your local machine
host: localhost:4000
# basePath prefixes all resource paths
basePath: /api
#
schemes:
  # tip: remove http to make production-grade
  - http
# format of bodies a client can send (Content-Type)
consumes:
  - application/json
# format of the responses to the client (Accepts)
produces:
  - application/json

securityDefinitions:
  authorization:
    x-authorize: security/auth.js
    scopes:
      default: Default Scope
  
  clientPortalAuthorization: 
    x-authorize: security/clientPortalAuth.js
    scopes:
      default: Default Scope

security:
  - authorization: [ default ]

tags:
  - name: user
    description: User namespace
  - name: password
    description: Password namespace
  - name: company
    description: Company namespace
  - name: client
    description: Client Namespace
  - name: task
    description: Task Namespace
  - name: engagement
    description: Engagement Namespace
  - name: contact
    description: Contact Namespace
  - name: document_request
    description: Document Request Namespace
  - name: note
    description: Note Namespace
  - name: event
    description: Event Namespace
  - name: field
    description: Field Namespace
  - name: team
    description: Team Namespace
  - name: role
    description: Role Namespace
  - name: view
    description: View Namespace
  - name: invoice
    description: View Namespace
  - name: subscription
    description: View Namespace
  - name: customer
    description: Customer Namespace
  - name: service
    description: Service Namespace
  - name: integration
    description: Integration Namespace
  - name: project
    description: Project Namespace
  - name: client_portal
    description: Client Portal Namespace
  - name: plaid_client
    description: Plaid Client Namespace
  - name: tools
    description: Tools Namespace
  - name: utility
    description: Utilities Namespace
  - name: faq
    description: FAQ Namespace
  - name: communication
    description: Client Communication Logger Namespace
  - name: tracker
    description: Engagement Tracker Namespace
  - name: data_mapper
    description: Data Mapper Namespace
  - name: gmail
    description: Gmail Inbox Namespace
  - name: backoffice
    description: Backoffice Namespace

paths:

  /user/login:
    post:
      description: Attempt to log the user in
      tags: [ user ]
      operationId: login

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/logout:
    post:
      description: Attempt to logout the user
      tags: [ user ]
      operationId: logout

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/connect:
    get:
      description: Get Google OAuth URL for user
      tags: [ user ]
      operationId: connectGoogle

      security:
        - authorization: [ default ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/callback:
    get:
      description: Google OAuth callback
      tags: [ user ]
      operationId: googleCallback

      security: []

      responses:
        "302":
          description: Redirect
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/status:
    get:
      description: Get Google OAuth connection status
      tags: [ user ]
      operationId: googleStatus

      security:
        - authorization: [ default ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/disconnect:
    delete:
      description: Disconnect Google OAuth
      tags: [ user ]
      operationId: googleDisconnect

      security:
        - authorization: [ default ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/create:
    post:
      description: Create a user
      tags: [ user ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/{userId}/update:
    post:
      description: Update a user
      tags: [ user ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/preferences/update:
    post:
      description: Update user preferences
      tags: [ user ]
      operationId: updatePreferences

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/preferences/list:
    get:
      description: Get list of user preferences
      tags: [ user ]
      operationId: listPreferences

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/list:
    get:
      description: Fetches a list of users.
      tags: [ user ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/search:
    post:
      description: Searches a list of users by their first name or last name
      tags: [ user ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/{userId}:
    get:
      description: Fetches a single user.
      tags: [ user ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/validate_token:
    get:
      description: Validates a user token
      tags: [ user ]
      operationId: validateToken

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
            
  /task/bulk_update:
    post:
      description: Updates more than one task at once
      tags: [ task ]
      operationId: bulk_update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /password/reset/verify_token: 
    post:
      description: Verify reset token validity
      tags: [ password ]
      operationId: verifyResetPasswordToken
      security: []

    responses:
      "200":
        description: Success
        schema:
          $ref: "#/definitions/Response"
      default:
        description: Error
        schema:
          $ref: "#/definitions/Response"

  /password/reset:
    post:
      description: Reset the password
      tags: [ password ]
      operationId: resetPassword 

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /password/reset/send_token:
    post:
      description: Send email for resetting password
      tags: [ password ]
      operationId: sendResetPasswordToken 
      
      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/create:
    post:
      description: Create a company
      tags: [ company ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/list:
    get:
      description: Fetch all companies
      tags: [ company ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/{companyId}/update:
    post:
      description: Update a company
      tags: [ company ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/{companyId}/logo:
    get:
      description: Get a company
      tags: [ company ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/{companyId}:
    get:
      description: Get a company
      tags: [ company ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/count:
    get:
      description: Counts all the engagements for a specific partner
      tags: [ engagement ]
      operationId: count

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/create:
    post:
      description: Create an engagement
      tags: [ engagement ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/multi_create:
    post:
      description: Create multiple engagements for different clients and flows
      tags: [ engagement ]
      operationId: multiCreate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/multi_delete:
    post:
      description: Delete multiple engagements for different clients and flows
      tags: [ engagement ]
      operationId: multiDelete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"            

  /engagement/list:
    get:
      description: Fetch all engagements
      tags: [ engagement ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/export:
    post:
      description: Retrieve a list of engagements
      tags: [ engagement ]
      operationId: exportList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/update:
    post:
      description: Update an engagement
      tags: [ engagement ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}:
    get:
      description: Get an engagement
      tags: [ engagement ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/delete:
    post:
      description: Delete an engagement
      tags: [ engagement ]
      operationId: delete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/create:
    post:
      description: Create an engagement budget
      tags: [ engagement ]
      operationId: createBudget

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/update:
    post:
      description: Update an engagement budget
      tags: [ engagement ]
      operationId: updateBudget

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/list:
    get:
      description: Get an engagement budget
      tags: [ engagement ]
      operationId: listBudgets

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/remove:
    post:
      description: Create an engagement budget
      tags: [ engagement ]
      operationId: removeBudget

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/create:
    post:
      description: Create a task
      tags: [ task ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/list:
    get:
      description: Fetch all tasks
      tags: [ task ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}/update:
    post:
      description: Update a task
      tags: [ task ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}/send_back:
    post:
      description: Send a task back to the previous step with a reason
      tags: [ task ]
      operationId: sendBack

      security: [
        authorization: [ default ]
      ]


      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}:
    get:
      description: Get a task
      tags: [ task ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}/mark_read:
    get:
      description: Sets the task as read
      tags: [ task ]
      operationId: markRead

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/create:
    post:
      description: Create a client
      tags: [ client ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/search:
    post:
      description: Create a client
      tags: [ client ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/list:
    get:
      description: Fetch all clients
      tags: [ client ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
            
  /client/summary:
    get:
      description: Get a full client breakdown for a company
      tags: [ client ]
      operationId: summary

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/export:
    post:
      description: Retrieve a CSV file of the current filtered clients
      tags: [ client ]
      operationId: exportList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/update:
    post:
      description: Update a client
      tags: [ client ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}:
    get:
      description: Get a client
      tags: [ client ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/remove_contact:
    post:
      description: Delete an contact from a client
      tags: [ client ]
      operationId: remove_contact

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  
  /client/{clientId}/delete:
    post:
      description: Delete an client
      tags: [ client ]
      operationId: delete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/custom_field:
    get:
      description: Get all the custom fields for a Client
      tags: [ client ]
      operationId: getCustomFields

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder:
    get:
      description: Get the active Google Drive folder mapping for a client
      tags: [ client ]
      operationId: getDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/provision:
    post:
      description: Auto-provision a Google Drive folder for a client
      tags: [ client ]
      operationId: provision

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/search:
    get:
      description: Search Google Drive for folders matching the client name
      tags: [ client ]
      operationId: searchDriveFolder

      security: [
        authorization: [ default ]
      ]

      parameters:
        - name: query
          in: query
          type: string
          required: false
        - name: pageToken
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/map:
    post:
      description: Manually map an existing Google Drive folder to a client
      tags: [ client ]
      operationId: mapDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/rename:
    post:
      description: Rename the linked Google Drive folder to match the client name
      tags: [ client ]
      operationId: renameDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/unlink:
    post:
      description: Remove the active Google Drive folder mapping for a client
      tags: [ client ]
      operationId: unlinkDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/{clientId}:
    get:
      description: Get a client
      tags: [ client_portal ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/list:
    get:
      description: Fetches a list of client groups
      tags: [ client ]
      operationId: listGroups

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/{clientGroupId}/update:
    post:
      description: Updates a specific client group
      tags: [ client ]
      operationId: updateClientGroup

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/{clientGroupId}:
    get:
      description: Fetches a specified client group
      tags: [ client ]
      operationId: getClientGroup

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/create:
    post:
      description: Creates a new client group
      tags: [ client ]
      operationId: createClientGroup

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/create:
    post:
      description: Create a contact
      tags: [ contact ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/list:
    get:
      description: Fetch all contacts
      tags: [ contact ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/search:
    post:
      description: Search for contacts
      tags: [ contact ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/{contactId}/update:
    post:
      description: Update a contact
      tags: [ contact ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/{contactId}/assign:
    post:
      description: Assign contact to a client
      tags: [ contact ]
      operationId: assign

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/{contactId}:
    get:
      description: Get a contact
      tags: [ contact ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"


  /document_request/create:
      post:
        description: Creates a new document request
        tags: [ document_request ]
        operationId: create
        security: [
            authorization: [
              default
            ]
        ]
        responses:
          "200":
            description: Success
            schema:
              $ref: "#/definitions/Response"
          default:
            description: Error
            schema:
              $ref: "#/definitions/Response"


  /document_request/upload:
    post:
      description: Handles client uploads
      tags: [ document_request ]
      operationId: upload

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
            

  /document_request/list:
    get:
      description: Lists all the document requests for a particular client
      tags: [ document_request ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /document_request/download/{shortId}:
    get:
      description: Creates a new document request
      tags: [ document_request ]
      operationId: download

      security: [
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /document_request/{shortId}:
    get:
      description: Fetches a document request
      tags: [ document_request ]
      operationId: get

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /flow/list:
    get:
      description: Fetches all the flows for a company
      tags: [ flow ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /flow/state/list:
    get:
      description: Fetches all the flow states for a flow
      tags: [ flow ]
      operationId: listStates

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /flow/{flowId}:
    get:
      description: Fetches a single flow
      tags: [ flow ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/{noteId}/update:
    post:
      description: Update a note
      tags: [ note ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/create:
    post:
      description: Create a note
      tags: [ note ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/list:
    get:
      description: Fetch all notes
      tags: [ note ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/{noteId}:
    get:
      description: Get a note
      tags: [ note ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /event/list:
    get:
      description: Fetch all events for a client or engagement
      tags: [ event ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/{fieldId}/update:
    post:
      description: Update a field
      tags: [ field ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/create:
    post:
      description: Create a field
      tags: [ field ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/list:
    get:
      description: Fetch all fields
      tags: [ field ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/{fieldId}:
    get:
      description: Get a field
      tags: [ field ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/{teamId}/update:
    post:
      description: Update a team
      tags: [ team ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/create:
    post:
      description: Create a team
      tags: [ team ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/list:
    get:
      description: Fetch all teams for a company
      tags: [ team ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/{teamId}:
    get:
      description: Get a team
      tags: [ team ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/{roleId}/update:
    post:
      description: Update a role
      tags: [ role ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/create:
    post:
      description: Create a role
      tags: [ role ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/list:
    get:
      description: Fetch all roles for a company
      tags: [ role ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/{roleId}:
    get:
      description: Get a role
      tags: [ role ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/create:
    post:
      description: Create a view
      tags: [ view ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/list:
    get:
      description: Fetch all views for a user
      tags: [ view ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}/subscribe:
    post:
      description: Toggle a user's subscription to a view.
      tags: [ view ]
      operationId: subscribeToView
      security:
        - authorization: [ default ]
      parameters:
        - name: viewId
          in: path
          required: true
          type: integer
          description: ID of the view.
        - name: body
          in: body
          required: true
          schema:
            type: object
            properties:
              userId:
                type: integer
              subscribe:
                type: boolean
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}/subscriptionStatus:
    get:
      description: Get the subscription status for a view for the current user.
      tags: [ view ]
      operationId: getSubscriptionStatus
      security:
        - authorization: [ default ]
      parameters:
        - name: viewId
          in: path
          required: true
          type: integer
          description: ID of the view.
        - name: userId
          in: query
          required: true
          type: integer
          description: ID of the current user.
      responses:
        "200":
          description: Subscription status retrieved successfully.
          schema:
            type: object
            properties:
              success:
                type: boolean
              isSubscribed:
                type: boolean
        default:
          description: Error retrieving subscription status.
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}/update:
    post:
      description: Update a view
      tags: [ view ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{userId}/view_user/update:
    post:
        description: Update a view_user record
        tags: [ view ]
        operationId: updateViewUser

        security: [
          authorization: [ default ]
        ]
 
        responses:
          "200":
            description: Success
            schema:
              $ref: "#/definitions/Response"
          default:
            description: Error
            schema:
              $ref: "#/definitions/Response"

  /view/{userId}/view_user/list:
    get:
      description: List view_user records
      tags: [ view ]
      operationId: listViewUser

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}:
    get:
      description: Get a view
      tags: [ view ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/create:
    post:
      description: Create an engagement template
      tags: [ engagement ]
      operationId: createTemplate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/list:
    get:
      description: Fetch all engagement templates for a company
      tags: [ engagement ]
      operationId: listTemplates

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/{engagementTemplateId}/update:
    post:
      description: Update an engagement template
      tags: [ engagement ]
      operationId: updateTemplate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/{engagementTemplateId}:
    get:
      description: Get an engagement template
      tags: [ engagement ]
      operationId: getTemplate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/create:
    post:
      description: Create an invoice
      tags: [ invoice ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/sync:
    post:
      description: Syncs a list of invoices to the necessary integrations
      tags: [ invoice ]
      operationId: sync

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/list:
    get:
      description: Fetch all invoices for a client
      tags: [ invoice ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/{invoiceId}/update:
    post:
      description: Update an invoice
      tags: [ invoice ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/{invoiceId}:
    get:
      description: Get an invoice
      tags: [ invoice ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/create:
    post:
      description: Create a subscription
      tags: [ subscription ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/list:
    get:
      description: Fetch all subscriptions for a client
      tags: [ subscription ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/{subscriptionId}/update:
    post:
      description: Update an subscription
      tags: [ subscription ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/{subscriptionId}:
    get:
      description: Get a subscription
      tags: [ subscription ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/service/list:
    get:
      description: Fetch all services for a client
      tags: [ service ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /support/create:
    post:
      description: Create a card
      tags: [ support ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /customer/list:
    get:
      description: Lists customers of client
      tags: [ customer ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/auth:
    get:
      description: Get Consent UI Link for Intuit OAuth
      tags: [ integration ]
      operationId: qboAuth

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/redirect:
    get:
      description: Get Consent UI Link for Intuit OAuth
      tags: [ integration ]
      operationId: qboRedirect

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/companies:
    get:
      description: List all authenticated QBO companies (realms)
      tags: [ integration ]
      operationId: qboCompanies

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/companies/{realmId}/customers:
    get:
      description: Get QBO customers for a given realm
      tags: [ integration ]
      operationId: qboCustomers

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/sub-resource/identifier/action

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/map-client:
    post:
      description: Map a workflow client to a QBO realm
      tags: [ integration ]
      operationId: qboMapClient

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/project/list:
    get:
      description: Get a list of TeamWork projects
      tags: [ project ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/recurring/{recurringEngagementId}/update:
    post:
      description: Update a recurring engagement record
      tags: [ engagement ]
      operationId: updateRecurringEngagement

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/recurring/list:
    get:
      description: Get list of recurring engagements
      tags: [ engagement ]
      operationId: listRecurringEngagements

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/download_summaries:
    post:
      description: Downloads the Excel bookkeeping summary
      tags: [ tools ]
      operationId: downloadBookkeepingSummaries

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/classify:
    post:
      description: Classifies transactions
      tags: [ tools ]
      operationId: classifyBookkeepingTransactions

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/categorize_from_gl:
    post:
      description: Categorizes transactions by fuzzy-matching their descriptions against a general ledger reference
      tags: [ tools ]
      operationId: categorizeFromGl

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/identify_bank_accounts_from_gl:
    post:
      description: Identifies which general ledger account names are likely real-world bank or credit card accounts
      tags: [ tools ]
      operationId: identifyBankAccountsFromGl

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/convert_currency:
    post:
      description: Converts foreign-currency transactions to CAD using the Bank of Canada daily exchange rate for each transaction's date
      tags: [ tools ]
      operationId: convertCurrency

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance:
    post:
      description: getBookkeepingTrialBalance
      tags: [ tools ]
      operationId: getBookkeepingTrialBalance
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/get_gl_opening_balance_lines:
    post:
      description: getGlOpeningBalanceLines
      tags: [ tools ]
      operationId: getGlOpeningBalanceLines
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/map_coa:
    get:
      description: getCoaMapping
      tags: [ tools ]
      operationId: getCoaMapping
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: mapCoaSuggest
      tags: [ tools ]
      operationId: mapCoaSuggest
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: mapCoaSave
      tags: [ tools ]
      operationId: mapCoaSave
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/ensure_engagement:
    post:
      description: ensureEngagement
      tags: [ tools ]
      operationId: ensureEngagement
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/register_statements:
    post:
      description: registerStatements
      tags: [ tools ]
      operationId: registerStatements
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_registry:
    post:
      description: readStatementRegistry
      tags: [ tools ]
      operationId: readStatementRegistry
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/imported_files:
    get:
      description: listImportedFiles
      tags: [ tools ]
      operationId: listImportedFiles
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/imported_files_remove:
    post:
      description: removeImportedFile
      tags: [ tools ]
      operationId: removeImportedFile
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_reading:
    get:
      description: readStatementReading
      tags: [ tools ]
      operationId: readStatementReading
      security: [
        authorization: [ default ]
      ]
      parameters:
        - name: statementId
          in: query
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

    post:
      description: correctStatementReading
      tags: [ tools ]
      operationId: correctStatementReading
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_correction_to_books:
    post:
      description: putStatementCorrectionInTheBooks
      tags: [ tools ]
      operationId: putStatementCorrectionInTheBooks
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/reread_statement_file:
    post:
      description: rereadStatementFile
      tags: [ tools ]
      operationId: rereadStatementFile
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/record_statement_by_hand:
    post:
      description: recordStatementByHand
      tags: [ tools ]
      operationId: recordStatementByHand
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/earnings_close:
    get:
      description: What the prior year's profit is and which equity account it would close into
      tags: [ tools ]
      operationId: getEarningsClose
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/earnings_close/update:
    post:
      description: Records which equity account an imported prior year's profit closes into
      tags: [ tools ]
      operationId: updateEarningsClose
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/opening_balances:
    get:
      description: getOpeningBalances
      tags: [ tools ]
      operationId: getOpeningBalances
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveOpeningBalances
      tags: [ tools ]
      operationId: saveOpeningBalances
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/chart_of_accounts:
    post:
      description: createChartOfAccount
      tags: [ tools ]
      operationId: createChartOfAccount
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_transactions:
    get:
      description: getEngagementTransactions
      tags: [ tools ]
      operationId: getEngagementTransactions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveEngagementTransactions
      tags: [ tools ]
      operationId: saveEngagementTransactions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: clearEngagementTransactions
      tags: [ tools ]
      operationId: clearEngagementTransactions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_transactions_by_account:
    get:
      description: getEngagementTransactionsByAccount
      tags: [ tools ]
      operationId: getEngagementTransactionsByAccount
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_adjusting_entries:
    get:
      description: getEngagementAdjustingEntries
      tags: [ tools ]
      operationId: getEngagementAdjustingEntries
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveEngagementAdjustingEntries
      tags: [ tools ]
      operationId: saveEngagementAdjustingEntries
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_fs_notes:
    get:
      description: getEngagementFsNotes
      tags: [ tools ]
      operationId: getEngagementFsNotes
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveEngagementFsNotes
      tags: [ tools ]
      operationId: saveEngagementFsNotes
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/rerun_cross_checks:
    post:
      description: rerunCrossChecks
      tags: [ tools ]
      operationId: rerunCrossChecks
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/update_engagement_context:
    post:
      description: updateEngagementContext
      tags: [ tools ]
      operationId: updateEngagementContext
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_years:
    get:
      description: getEngagementYears
      tags: [ tools ]
      operationId: getEngagementYears
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_deliverable:
    get:
      description: getEngagementDeliverable
      tags: [ tools ]
      operationId: getEngagementDeliverable
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance_import_commit:
    post:
      description: commitTrialBalanceImport
      tags: [ tools ]
      operationId: commitTrialBalanceImport
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance_import_clear:
    post:
      description: clearTrialBalanceImport
      tags: [ tools ]
      operationId: clearTrialBalanceImport
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance_import_preview:
    post:
      description: previewTrialBalanceImport
      tags: [ tools ]
      operationId: previewTrialBalanceImport
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/package_checklist:
    get:
      description: getPackageChecklist
      tags: [ tools ]
      operationId: getPackageChecklist
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

    post:
      description: recordPackageItemDecision
      tags: [ tools ]
      operationId: recordPackageItemDecision
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/package_checklist_delete:
    post:
      description: removeManualPackageItem
      tags: [ tools ]
      operationId: removeManualPackageItem
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/package_document:
    post:
      description: uploadPackageDocument
      tags: [ tools ]
      operationId: uploadPackageDocument
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_presentation_settings:
    get:
      description: getEngagementPresentationSettings
      tags: [ tools ]
      operationId: getEngagementPresentationSettings
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

    post:
      description: setEngagementPresentationSettings
      tags: [ tools ]
      operationId: setEngagementPresentationSettings
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/roll_forward:
    post:
      description: rollForward
      tags: [ tools ]
      operationId: rollForward
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_signoff:
    get:
      description: getEngagementSignoff
      tags: [ tools ]
      operationId: getEngagementSignoff
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createEngagementSignoff
      tags: [ tools ]
      operationId: createEngagementSignoff
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/year_end_package:
    get:
      description: getYearEndPackage
      tags: [ tools ]
      operationId: getYearEndPackage
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createYearEndPackage
      tags: [ tools ]
      operationId: createYearEndPackage
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/client_requests:
    get:
      description: getClientRequests
      tags: [ tools ]
      operationId: getClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createClientRequests
      tags: [ tools ]
      operationId: createClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateClientRequests
      tags: [ tools ]
      operationId: updateClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: deleteClientRequests
      tags: [ tools ]
      operationId: deleteClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/client_requests_send:
    post:
      description: createClientRequestsSend
      tags: [ tools ]
      operationId: createClientRequestsSend
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/lead_sheets:
    get:
      description: getLeadSheets
      tags: [ tools ]
      operationId: getLeadSheets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateLeadSheets
      tags: [ tools ]
      operationId: updateLeadSheets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/record_missed_statement_line:
    post:
      description: Records a line that is on the statement but that the reader never produced
      tags: [ tools ]
      operationId: recordMissedStatementLine
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/accept_unreconciled_statements:
    post:
      description: Records that a preparer accepts working on books their statements do not support
      tags: [ tools ]
      operationId: acceptUnreconciledStatements
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_lines:
    get:
      description: Lists statements whose lines do not account for the movement they print
      tags: [ tools ]
      operationId: getStatementsThatDoNotReconcile
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

    post:
      description: Records a line that is on the statement but never made it into the books
      tags: [ tools ]
      operationId: addLineReadOffTheStatement
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/transfer_pairs:
    post:
      description: Records pairs of statement lines as payments between the client's own accounts
      tags: [ tools ]
      operationId: recordTransferPairs
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/transfer_pairs/release:
    post:
      description: Undoes a transfer match so both legs post again
      tags: [ tools ]
      operationId: releaseTransferPair
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/bank_account_links:
    get:
      description: Lists each imported bank or card account with the chart account it posts to
      tags: [ tools ]
      operationId: getBankAccountLinks
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/bank_account_links/update:
    post:
      description: Points an imported bank or card account at a different account on the client's chart
      tags: [ tools ]
      operationId: updateBankAccountLink
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/lead_sheet_documents:
    get:
      description: getLeadSheetDocuments
      tags: [ tools ]
      operationId: getLeadSheetDocuments
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateLeadSheetDocuments
      tags: [ tools ]
      operationId: updateLeadSheetDocuments
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: deleteLeadSheetDocuments
      tags: [ tools ]
      operationId: deleteLeadSheetDocuments
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/canonical_accounts:
    get:
      description: getCanonicalAccounts
      tags: [ tools ]
      operationId: getCanonicalAccounts
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/reconciliation_action:
    post:
      description: createReconciliationAction
      tags: [ tools ]
      operationId: createReconciliationAction
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateReconciliationAction
      tags: [ tools ]
      operationId: updateReconciliationAction
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/fixed_assets:
    get:
      description: getFixedAssets
      tags: [ tools ]
      operationId: getFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createFixedAssets
      tags: [ tools ]
      operationId: createFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateFixedAssets
      tags: [ tools ]
      operationId: updateFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: deleteFixedAssets
      tags: [ tools ]
      operationId: deleteFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/fixed_asset_register:
    post:
      description: fixedAssetRegister
      tags: [ tools ]
      operationId: fixedAssetRegister
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_templates:
    get:
      description: getEngagementTemplates
      tags: [ tools ]
      operationId: getEngagementTemplates
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/batch_tax_codes:
    post:
      description: batchTaxCodes
      tags: [ tools ]
      operationId: batchTaxCodes
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/infer_industry:
    post:
      description: inferIndustry
      tags: [ tools ]
      operationId: inferIndustry
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/documentation_checklist:
    post:
      description: Fetch the documentation checklist for a client's engagement
      tags: [ tools ]
      operationId: documentationChecklist
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/verify_document_again:
    post:
      description: Runs the document check again when the last attempt finished without an answer
      tags: [ tools ]
      operationId: verifyDocumentAgain
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/agent_mode_clear:
    post:
      description: Clear the agent mode state for a client
      tags: [ tools ]
      operationId: agentModeClear
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/agent_mode_manifest:
    post:
      description: Fetch the agent mode manifest for a client
      tags: [ tools ]
      operationId: agentModeManifest
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/review:
    post:
      description: Generate an AI review of the AFS financial statements
      tags: [ tools ]
      operationId: reviewAFS
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_checklist:
    post:
      description: Retrieve the compliance checklist for a client
      tags: [ tools ]
      operationId: complianceChecklist
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_evidence:
    post:
      description: Set or clear a compliance evidence value for a client
      tags: [ tools ]
      operationId: complianceEvidence
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_document:
    delete:
      description: Delete a compliance document for a client
      tags: [ tools ]
      operationId: deleteComplianceDocument
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_acknowledge:
    post:
      description: Acknowledge or unacknowledge a compliance item for a client
      tags: [ tools ]
      operationId: complianceAcknowledge
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/auth_url:
    get:
      description: Get Google OAuth consent URL for connecting a user's Gmail account
      tags: [ gmail ]
      operationId: gmailAuthUrl
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/status:
    get:
      description: Returns whether the current user has Gmail connected
      tags: [ gmail ]
      operationId: gmailStatus
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/disconnect:
    post:
      description: Disconnects the current user's Gmail account
      tags: [ gmail ]
      operationId: gmailDisconnect
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/classify_tax:
    post:
      description: Classifies transactions for tax
      tags: [ tools ]
      operationId: classifyAccountsTax

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/upload_caseware_reference:
    post:
      description: Uploads a Caseware reference file
      tags: [ tools ]
      operationId: uploadCasewareReference

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/reconciliation/upload:
    post:
      description: Upload PDF and Excel docs for reconciliation
      tags: [ tools ]
      operationId: upload

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/reconciliation/download:
    post:
      description: Downloads the Excel reconciliation
      tags: [ tools ]
      operationId: download

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/hstReconciliation/download:
    post:
      description: Downloads the Excel reconciliation
      tags: [ tools ]
      operationId: download

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/hstReconciliation/downloadQuickMethod:
    post:
      description: Downloads the Quick Method Excel reconciliation
      tags: [ tools ]
      operationId: download

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/accounts:
    get:
      description: List QBO loan / liability accounts available for loan reconciliation
      tags: [ tools ]
      operationId: loanReconAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/run:
    post:
      description: Run a loan reconciliation by uploading a lender's PDF statement
      tags: [ tools ]
      operationId: loanReconRun

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/history:
    get:
      description: List historical loan reconciliations for a client
      tags: [ tools ]
      operationId: loanReconHistory

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/get:
    get:
      description: Get the amortization schedule and history for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/generate:
    post:
      description: Generate an amortization schedule from provided loan terms
      tags: [ tools ]
      operationId: loanReconScheduleGenerate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/upload:
    post:
      description: Upload an amortization schedule file for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleUpload

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/replace:
    post:
      description: Replace an amortization schedule starting from a given date
      tags: [ tools ]
      operationId: loanReconScheduleReplace

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/recalculate:
    post:
      description: Recalculate the amortization schedule based on updated terms
      tags: [ tools ]
      operationId: loanReconScheduleRecalculate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/reset:
    post:
      description: Reset an existing amortization schedule for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleReset

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/updateRow:
    patch:
      description: Update status or notes on an amortization schedule row
      tags: [ tools ]
      operationId: loanReconScheduleUpdateRow

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/year:
    get:
      description: Get the amortization schedule year overview for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleYear

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/accounts:
    get:
      description: List QBO bank accounts available for reconciliation
      tags: [ tools ]
      operationId: bankReconAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/run:
    post:
      description: Run a bank reconciliation for a specific account and period
      tags: [ tools ]
      operationId: bankReconRun

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/get:
    get:
      description: Get a bank reconciliation by ID (pass reconciliationId as query param)
      tags: [ tools ]
      operationId: bankReconGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/list:
    get:
      description: List reconciliation history for a client
      tags: [ tools ]
      operationId: bankReconList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/list_all:
    get:
      description: List all reconciliations across all clients for a given month
      tags: [ tools ]
      operationId: bankReconListAll

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/data_quality_alerts:
    get:
      description: List active data quality alerts for a client
      tags: [ tools ]
      operationId: bankReconDataQualityAlerts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: Acknowledge or resolve a data quality alert
      tags: [ tools ]
      operationId: bankReconAcknowledgeDataQualityAlert

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/duplicate_decisions:
    post:
      description: Save a user's duplicate review decision (exclude/keep)
      tags: [ tools ]
      operationId: bankReconSaveDuplicateDecision

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/update_item:
    post:
      description: Update a reconciliation item match status or category
      tags: [ tools ]
      operationId: bankReconUpdateItem

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/download:
    post:
      description: Download bank reconciliation as Excel file
      tags: [ tools ]
      operationId: bankReconDownload

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/auto_recon_settings:
    post:
      description: Enable/disable auto-reconciliation and map Plaid + QBO accounts
      tags: [ tools ]
      operationId: bankReconAutoReconSettings

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/update_adjustment:
    post:
      description: Accept or reject a reconciliation adjustment
      tags: [ tools ]
      operationId: bankReconUpdateAdjustment

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/post_adjustment:
    post:
      description: Post an accepted adjustment as a journal entry to QBO
      tags: [ tools ]
      operationId: bankReconPostAdjustment

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/connect/create_short_link:
    get:
      description: Creates a Plaid short link that can be shared with clients
      tags: [ tools ]
      operationId: createPlaidShortLink

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/connect/create_link_token:
    get:
      description: Creates a Plaid link token to start the plaid connection process
      tags: [ tools ]
      operationId: createPlaidLinkToken

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/links:
    get:
      description: Fetches all the connection plaid links for a client
      tags: [ tools ]
      operationId: fetchPlaidLinks

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/send_connect_email:
    post:
      description: Will send a plaid link connect email to the contact
      tags: [ tools ]
      operationId: sendConnectEmail

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/health:
    get:
      description: Check Plaid connection health for a client
      tags: [ tools ]
      operationId: plaidHealth

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/connect/create_update_link_token:
    get:
      description: Create a Plaid Link token in update mode for re-authentication
      tags: [ tools ]
      operationId: createUpdateLinkToken

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/accounts:
    get:
      description: Fetches all the connected accounts for a Plaid account to a client
      tags: [ tools ]
      operationId: fetchPlaidAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/transactions:
    get:
      description: Fetches a list of transactions for a given account connected to workflow client and plaid account
      tags: [ tools ]
      operationId: fetchPlaidTransactions

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/hooks/webhook:
    post:
      description: Plaid Webhooks
      tags: [ tools ]
      operationId: plaidWebhook

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /utility/crons/process_recurring_engagements:
    post:
      description: Test Cron endpoint
      tags: [ utility ]
      operationId: processRecurringEngagements

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/email_new_account_setup:
    post:
      description: Setup account 
      tags: [ client_portal ]
      operationId: emailNewAccountSetup
      security: []
      parameters:
        - name: body
          in: body
          required: true
          schema:
            type: object
            properties:
              contactId:
                type: integer
            required:
              - contactId
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/email_reset_password:
    post:
      description: Reset account password
      tags: [ client_portal ]
      operationId: emailResetPassword
      security: [ ]
      parameters:
        - name: body
          in: body
          description: email reset body request
          required: true
          schema:
            type: object
            properties:
              contactEmail:
                type: string
            required:
              - contactEmail
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
        
  /client_portal/user/{contactId}/get_clients:
    get:
      description: get list of clients for user
      tags: [ client_portal ]
      operationId: getClients
      security: [ clientPortalAuthorization: [ default ]  ]
      parameters:
        - name: contactId
          in: path
          description: The ID of the contact
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/login:
    post:
      description: Login
      tags: [ client_portal ]
      operationId: login
      security: [ ]
      parameters:
        - in: body
          name: body
          description: Login request body
          required: true
          schema:
            type: object
            properties:
              email:
                type: string
              password:
                type: string
            required:
              - email
              - password
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/setup_account:
    post: 
      description: Setup account
      tags: [ client_portal ]
      operationId: setupAccount
      security: []
      parameters:
        - in: body
          name: body
          description: Setup account request body
          required: true
          schema:
            type: object
            properties:
              email:
                type: string
              password:
                type: string
              confirmedPassword:
                type: string
              setupToken: 
                type: string
            required:
              - email
              - password
              - confirmedPassword
              - setupToken
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/user/{contactId}:
    get:
      description: Get a user
      tags: [ client_portal ]
      operationId: getUser
      security: [
         clientPortalAuthorization: [ default ] 
      ]
      parameters:
      - name: contactId
        in: path
        description: The ID of the contact
        required: true
        type: integer
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/file/upload:
    post:
      description: Upload a file
      consumes:
        - multipart/form-data
      tags: [ client_portal ]
      operationId: uploadFile
      security: [
         clientPortalAuthorization: [ default ] 
      ]
      parameters:
        - name: companyId
          in: formData
          description: Company ID
          required: true
          type: integer
        - name: clientId
          in: formData
          description: Client ID
          required: true
          type: integer
        - name: files
          in: formData
          description: Files to upload
          # required is not supported for files with swagger
          type: array
          items:
            type: string
            format: binary

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/file/remove:
    post:
      description: Delete a file
      tags: [ client_portal ]
      operationId: deleteFile
      security: [
         clientPortalAuthorization: [ default ] 
      ]
      parameters:
        - name: body
          in: body
          description: Delete file request body
          required: true
          schema:
            type: object
            properties:
              documentId:
                type: integer
              clientId:
                type: integer
              companyId:
                type: integer
            required:
              - documentId
              - clientId
              - companyId
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  
  /client_portal/file/list:
    get:
      description: List files
      tags: [ client_portal ]
      operationId: listFiles
      security:
        - clientPortalAuthorization: [ default ]
      parameters:
        - name: clientId
          in: query
          description: The client ID
          required: true
          type: integer
        - name: search
          in: query
          description: Search term
          required: false
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/file/download:
    get:
      description: Download a file
      tags: [ client_portal ]
      operationId: downloadFile
      security: [
         clientPortalAuthorization: [ default ] 
      ]
      parameters:
        - name: companyId
          in: query
          description: Company ID
          required: true
          type: integer
        - name: documentId
          in: query
          description: Document ID
          required: true
          type: integer
        - name: clientId
          description: client id of user
          in: query
          required: true
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/google_drive/auth_url:
    get:
      description: Authenticate with Google Drive
      tags: [ client_portal ]
      operationId: auth_url
      security: []
      parameters:
        - name: companyId
          in: query
          description: Company ID
          required: true
          type: integer
        - name: clientId
          in: query
          description: Client ID
          required: true
          type: string
        - name: clientSecret
          in: query
          description: Client Secret
          required: true
          type: string
        - name: sharedDriveName
          in: query
          description: Shared drive name where files are stored
          required: true
          type: string

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  
  /client_portal/google_drive/callback:
    get:
      description: set token of google drive
      tags: [ client_portal ]
      operationId: callback
      security: []
      parameters:
        - name: code
          in: query
          required: true
          type: string
        - name: state
          in: query
          description: proxy state that is passed from auth url
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/{token}:
    get:
      description: Verify account setup auth token
      tags: [ client_portal ]
      operationId: verifyToken
      security: []
      parameters:
        - name: token
          in: path
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /faq/list:
    get:
      description: Fetch all active FAQ items
      tags: [ faq ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /faq/search:
    post:
      description: AI-powered semantic search across FAQ transcripts
      tags: [ faq ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/list:
    post:
      description: List communications, optionally filtered by client, assignment, type, source, or date range
      tags: [ communication ]
      operationId: listCommunications

      security:
        - authorization: [ default ]
  /tracker/list:
    get:
      description: List the current user's tracker forms
      tags: [ tracker ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/create:
    post:
      description: Create a new tracker form
      tags: [ tracker ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/create:
    post:
      description: Manually log a communication for a client
      tags: [ communication ]
      operationId: createCommunication

      security:
        - authorization: [ default ]
  /tracker/rename:
    post:
      description: Rename a tracker form
      tags: [ tracker ]
      operationId: rename

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/{communicationId}:
    get:
      description: Get a single communication with its AI summary
      tags: [ communication ]
      operationId: getCommunication

      security:
        - authorization: [ default ]
  /tracker/delete:
    post:
      description: Archive a tracker form
      tags: [ tracker ]
      operationId: delete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/{communicationId}/delete:
    post:
      description: Delete a logged communication
      tags: [ communication ]
      operationId: deleteCommunication

      security:
        - authorization: [ default ]
  /tracker/share:
    post:
      description: Share a tracker with the company or make it private
      tags: [ tracker ]
      operationId: share

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/{communicationId}/assign:
    post:
      description: Assign an unmatched communication to a client
      tags: [ communication ]
      operationId: assignCommunication

      security:
        - authorization: [ default ]
  /tracker/save-config:
    post:
      description: Persist a tracker's view config
      tags: [ tracker ]
      operationId: saveConfig

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/meet/list:
    post:
      description: List Google Meet transcript docs available to import for a client
      tags: [ communication ]
      operationId: listMeetRecordings

      security:
        - authorization: [ default ]
  /tracker/field-add:
    post:
      description: Add a column to a tracker form
      tags: [ tracker ]
      operationId: fieldAdd

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/meet/import:
    post:
      description: Import selected Google Meet transcripts as communication entries
      tags: [ communication ]
      operationId: importMeetRecordings

      security:
        - authorization: [ default ]
  /tracker/field-update:
    post:
      description: Update a tracker column
      tags: [ tracker ]
      operationId: fieldUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/meetings/create:
    post:
      description: Schedule a Google Meet meeting for a client and store the calendar event link
      tags: [ client ]
      operationId: createMeeting

      security:
        - authorization: [ default ]
  /client/{clientId}/meetings/availability:
    post:
      description: Free/busy of the organizer and staff attendees for a proposed meeting slot
      tags: [ client ]
      operationId: meetingAvailability

      security:
        - authorization: [ default ]
  /tracker/field-delete:
    post:
      description: Delete a tracker column
      tags: [ tracker ]
      operationId: fieldDelete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/meetings/list:
    get:
      description: List scheduled meetings for a client
      tags: [ client ]
      operationId: listMeetings

      security:
        - authorization: [ default ]

  /tracker/field-reorder:
    post:
      description: Reorder tracker columns
      tags: [ tracker ]
      operationId: fieldReorder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/grid:
    post:
      description: Get the full tracker grid (POST; body may include filterTree)
      tags: [ tracker ]
      operationId: grid

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/value-upsert:
    post:
      description: Upsert a tracker cell value
      tags: [ tracker ]
      operationId: valueUpsert

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/engagement-patch:
    post:
      description: Patch a whitelisted native engagement field
      tags: [ tracker ]
      operationId: engagementPatch

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/field-list:
    post:
      description: List a form's columns for a resource
      tags: [ tracker ]
      operationId: fieldList
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/sub-grid:
    post:
      description: Load an engagement task/user sub-grid
      tags: [ tracker ]
      operationId: subGrid
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/sub-value-upsert:
    post:
      description: Upsert a sub-grid custom value
      tags: [ tracker ]
      operationId: subValueUpsert
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/task-patch:
    post:
      description: Patch a native task field / assignees
      tags: [ tracker ]
      operationId: taskPatch
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/user-patch:
    post:
      description: Patch a native user field / engagement member role
      tags: [ tracker ]
      operationId: userPatch
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/sub-row-add:
    post:
      description: Add a task or user member to an engagement sub-grid
      tags: [ tracker ]
      operationId: subRowAdd
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /data_mapper/registry:
    get:
      description: List datasource entities and relationships
      tags: [ data_mapper ]
      operationId: registry
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /data_mapper/resolve:
    post:
      description: Resolve datasource dropdown options
      tags: [ data_mapper ]
      operationId: resolve
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/auth-url:
    get:
      description: Build a Google OAuth consent URL for connecting a team's Gmail mailbox
      tags: [ gmail ]
      operationId: authUrl

      security: [
        authorization: [ default ]
      ]

      parameters:
        - name: teamId
          in: query
          required: true
          type: integer

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/account-list:
    get:
      description: List Gmail accounts the current user can access
      tags: [ gmail ]
      operationId: accountList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/account-disconnect:
    post:
      description: Disconnect a team Gmail account
      tags: [ gmail ]
      operationId: accountDisconnect

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/thread-list:
    get:
      description: List threads
      tags: [ gmail ]
      operationId: threadList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/thread-get:
    get:
      description: Get a thread
      tags: [ gmail ]
      operationId: threadGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/message-update:
    post:
      description: Update message labels
      tags: [ gmail ]
      operationId: messageUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/message-trash:
    post:
      description: Trash a message or thread
      tags: [ gmail ]
      operationId: messageTrash

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/label-list:
    get:
      description: List user labels
      tags: [ gmail ]
      operationId: labelList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-create:
    post:
      description: Create draft
      tags: [ gmail ]
      operationId: draftCreate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-update:
    post:
      description: Update draft
      tags: [ gmail ]
      operationId: draftUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-list:
    get:
      description: List drafts
      tags: [ gmail ]
      operationId: draftList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-get:
    get:
      description: Get a draft
      tags: [ gmail ]
      operationId: draftGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-delete:
    post:
      description: Discard a draft
      tags: [ gmail ]
      operationId: draftDelete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  # ---------------------------------------------------------------------------
  # Backoffice
  # ---------------------------------------------------------------------------

  /backoffice/client/list:
    get:
      description: Backoffice clients with their email contact
      tags: [ backoffice ]
      operationId: listClients

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/contacts:
    get:
      description: Contacts on a client, for picking the automation recipient
      tags: [ backoffice ]
      operationId: listClientContacts

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: clientId
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/create:
    post:
      description: Enrol a client in backoffice
      tags: [ backoffice ]
      operationId: createClient

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/{backofficeClientId}/update:
    post:
      description: Update a backoffice client's contact, notes or status
      tags: [ backoffice ]
      operationId: updateClient

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/{backofficeClientId}/remove:
    post:
      description: Remove a client from backoffice
      tags: [ backoffice ]
      operationId: removeClient

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/list:
    get:
      description: Backoffice tasks with accounts and email automations
      tags: [ backoffice ]
      operationId: listTasks

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: clientId
          in: query
          type: string
          required: false
        - name: service
          in: query
          type: string
          required: false
        - name: from
          in: query
          type: string
          required: false
        - name: to
          in: query
          type: string
          required: false
        - name: status
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/create:
    post:
      description: Create a backoffice task
      tags: [ backoffice ]
      operationId: createTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/update:
    post:
      description: Update a backoffice task; completing a recurring task creates the next occurrence
      tags: [ backoffice ]
      operationId: updateTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/remove:
    post:
      description: Delete a backoffice task
      tags: [ backoffice ]
      operationId: removeTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/restore:
    post:
      description: Bring back a deleted backoffice task
      tags: [ backoffice ]
      operationId: restoreTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/account/create:
    post:
      description: Add a tracked account to a task
      tags: [ backoffice ]
      operationId: addTaskAccount

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/account/{accountId}/update:
    post:
      description: Tick or edit a tracked account
      tags: [ backoffice ]
      operationId: updateTaskAccount

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/account/{accountId}/remove:
    post:
      description: Remove a tracked account from a task
      tags: [ backoffice ]
      operationId: removeTaskAccount

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/upsert:
    post:
      description: Save and activate the client email automation on a task
      tags: [ backoffice ]
      operationId: upsertTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/send_now:
    post:
      description: Send the automation email now and restart the cadence from today
      tags: [ backoffice ]
      operationId: sendTaskEmailNow

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/stop:
    post:
      description: Stop or pause the email automation on a task
      tags: [ backoffice ]
      operationId: stopTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/resume:
    post:
      description: Resume a stopped email automation from today
      tags: [ backoffice ]
      operationId: resumeTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/remove:
    post:
      description: Delete the email automation on a task
      tags: [ backoffice ]
      operationId: removeTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/email/send/{sendId}/skip:
    post:
      description: Skip one scheduled send
      tags: [ backoffice ]
      operationId: skipEmailSend

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/email/process_due:
    post:
      description: Deliver every due send now, administrators only (the cron does this in production)
      tags: [ backoffice ]
      operationId: processDueEmails

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/list:
    get:
      description: Backoffice task templates
      tags: [ backoffice ]
      operationId: listTemplates

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: includeInactive
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/create:
    post:
      description: Create a backoffice template
      tags: [ backoffice ]
      operationId: createTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/update:
    post:
      description: Update a backoffice template and its tasks
      tags: [ backoffice ]
      operationId: updateTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/remove:
    post:
      description: Delete a backoffice template
      tags: [ backoffice ]
      operationId: removeTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/preview:
    get:
      description: Preview the tasks a template would add for a client and period
      tags: [ backoffice ]
      operationId: previewTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: view
      parameters:
        - name: clientId
          in: query
          type: string
          required: false
        - name: periodStart
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/apply:
    post:
      description: Add a template's tasks to a client for a period
      tags: [ backoffice ]
      operationId: applyTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/capacity/list:
    get:
      description: Users with weekly backoffice capacity and teams
      tags: [ backoffice ]
      operationId: listCapacity

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/capacity/update:
    post:
      description: Set a user's weekly backoffice hours
      tags: [ backoffice ]
      operationId: updateCapacity

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/chart_of_accounts/list:
    get:
      description: A client's reconcilable balance-sheet accounts
      tags: [ backoffice ]
      operationId: listChartOfAccounts

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: clientId
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"


definitions:

  Request:
    description: Basic Request

  Response:
    description: A standard error response for all API methods.
`;
